import React, { Component } from 'react';
import { BrowserRouter, Route } from 'react-router-dom';
import Main from './components/Main';
import Project from './components/Project';
import Footer from './components/Footer';
import ScrollToTop from 'react-router-scroll-top';

const data = require('./js/data');

class App extends Component{
  constructor(props){
    super(props);
    this.state = {
      portfolioItems: data,
    }
  }

  getPortfolioItem = itemId => {
    return this.state.portfolioItems.projects.filter(item => item.id === Number(itemId));
  };


  render(){
    return (
        <div>
          <BrowserRouter basename={process.env.PUBLIC_URL}>
              <Route path="/" exact render={(props) => <Main projects={this.state.portfolioItems.projects} {...props} />} />
              <ScrollToTop>
                <Route path="/project/:id" render={(props) => <Project getItem={this.getPortfolioItem} {...props} />} />
              </ScrollToTop>
          </BrowserRouter>
          <Footer />
        </div>

    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js